import React, { useRef } from 'react'
import styles from './ExitIntentModal.module.scss'
import cx from 'classnames'
import FocusTrapWrapper from 'components/FocusTrapWrapper'
import { useClickOutsideModal } from 'hooks/useClickOutsideModal'

interface Props {
	className?: string
	emailCapModalVisible: boolean
	children: any
	handleClose: () => void
	preventMouse?: boolean
}

export const Wrapper: React.FC<Props> = (props: Props) => {
	const pageWrapper = useRef(null)
	useClickOutsideModal(pageWrapper, props.handleClose, props.preventMouse)

	return (
		<FocusTrapWrapper active={props.emailCapModalVisible}>
			<div className={cx('modal_container', props.className, { none: !props.emailCapModalVisible })}>
				<div
					className={styles.modal_content_container}
					ref={pageWrapper}
				>
					<button
						role="button"
						aria-label="Close modal button"
						className={styles.close_button}
						onClick={props.handleClose}
					>
						<img
							src="https://eightsleep.imgix.net/Close_Icon_1.png?v=1583943271"
							alt="Close Icon"
						/>
					</button>
					<div className={styles.modal_content}>
						<div>{props.children}</div>
					</div>
				</div>
			</div>
		</FocusTrapWrapper>
	)
}

export default Wrapper
